/**
 *  Possible type of a (child) reservation.
 */
export var ReservationRequestAction;
(function (ReservationRequestAction) {
    ReservationRequestAction["Reserve"] = "reserve";
    ReservationRequestAction["Release"] = "release";
})(ReservationRequestAction || (ReservationRequestAction = {}));
export var ReservationType;
(function (ReservationType) {
    ReservationType["Ticket"] = "Ticket";
    ReservationType["Product"] = "Product";
})(ReservationType || (ReservationType = {}));
//# sourceMappingURL=types.js.map